import FormAudit from '../sub-pages/form-audit';

export default[
    {
        show(row,extra){
            return true
        },
        tag:'my-btn',
        type:'detail',
        text:'详情',
        click(row,extra){
            this.goto({
                path: '/iframe',
                query: {
                    sh:'1',
                    id: row.ggcode,
                    url:'/FangAn/Zbgg/detail.do'
                }
            });
        }
    },{
        show(row,extra){
            return row.shbj=='1'
        },
        tag:'el-button',
        type:'text',
        icon: 'el-icon-finished',
        text: '审核',
        click(row,extra){
            this.dialogOpen(FormAudit,'审核')
        }
    },{
        show(row,extra){
            return row.shbj=='6'
        },
        tag:'el-button',
        type:'text',
        icon: 'el-icon-close',
        text: '公告退回',
        click(row,extra){
            var that = this
            ShowConfirm('确认退回招标公告？', 'danger', () => {
                that.$post(`${this.getGetters('mngUrl')}/manage/business/AuditZbgg/tuihuigg.json`, {
                    ggcode:row.ggcode
                }, (data, res) => {
                    ShowMsg('公告退回成功', 'success');
                    that.$emit('reload')
                });
            })
        }
    },
]